import { useQuery, UseQueryOptions } from '@tanstack/react-query'
import { RequestTypes } from '../requestTypes'
import { taskTemplateKeys } from '../taskTemplateKeys'
import { ITaskTemplate, TaskTemplate } from '@core/entities/task/TaskTemplate'
import { RequestErrorType } from '@core/utils/api-axios-instance'

const templateTransform = (response: ITaskTemplate) =>
  TaskTemplate.new(response)

export const useGetTaskTemplate = (
  payload: RequestTypes['getTaskTemplate'],
  options?: UseQueryOptions<ITaskTemplate, RequestErrorType, TaskTemplate>,
) => {
  return useQuery({
    select: templateTransform,
    ...taskTemplateKeys.getTaskTemplate(payload),
    ...options,
  })
}
